.hitbox {
  padding: var(--spacing);
}
.hitbox ui-icon {
  transition: opacity var(--duration) var(--easing);
  opacity: 0.6;
}
.hitbox:hover ui-icon {
  opacity: 1;
}
